import { BaseService } from "@/api/services/baseService";
import request from "@/api";
import type { Supplier, SupplierVo } from "@zhihaoscm/entity";
import { confirmable } from "@/utils/decorator/confirmable";

export class EnterpriseManageService extends BaseService<Supplier, SupplierVo, unknown, unknown> {
    /**
     * 查询供应商详情
     */
    public async getInfo(id: string): Promise<SupplierVo> {
        const { data } = await this.service.get(`${this.path}/find/${id}`);
        return data;
    }

    /**
     * 创建供应商
     */
    @confirmable("是否提交")
    public async addEnterprise(params: unknown): Promise<Supplier> {
        const { data } = await this.service.post(`${this.path}/create`, params);
        return data;
    }

    /**
     * 修改供应商
     */
    @confirmable("是否提交")
    public async updateEnterprise(id: string, params: unknown): Promise<Supplier> {
        const { data } = await this.service.put(`${this.path}/update/${id}`, params);
        return data;
    }

    /**
     * 删除供应商
     */
    @confirmable("是否删除")
    public async deleteEnterprise(id: number): Promise<Supplier> {
        const { data } = await this.service.delete(`${this.path}/delete/${id}`);
        return data;
    }
    /**
     * 下拉列表-商品列表使用 商品类型：1寄售 2团购 3捡漏
     */
    public async selectorByProduct(params: { productType: number; name?: string }): Promise<Supplier[]> {
        const { data } = await this.service.get(`${this.path}/selector-by-product`, { params });
        return data;
    }

    /**
     * 供应商下拉列表数据
     */
    public async selector(params?: { supplierName?: string }): Promise<Supplier[]> {
        const { data } = await this.service.get(`${this.path}/selector`, { params });
        return data;
    }
}

export const enterpriseManageService = new EnterpriseManageService("/admin/supplier-admin", request.service);
